import { Helmet } from 'react-helmet-async';
import siteContent from "../../data/siteContent.json";

const SEO = () => {
    const { general, about } = siteContent;
    const description = Array.isArray(about.description) ? about.description[0] : about.description;

    // Schema Markups (Structured Data)
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "FurnitureStore",
        "name": general.brandName,
        "image": "https://erdemobilya.com/assets/logos/ERDE-512.png", // Varsayılan URL
        "description": description,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": general.contact.address,
            "addressLocality": "Manisa",
            "addressCountry": "TR"
        },
        "telephone": general.contact.phone,
        "email": general.contact.email,
        "url": "https://erdemobilya.com/",
        "sameAs": [
            general.contact.instagram.url,
            general.contact.facebook
        ],
        "priceRange": "$$$$"
    };

    return (
        <Helmet>
            {/* Standard Meta Tags */}
            <title>{general.brandName} | Kişiye Özel Mobilya Üretimi</title>
            <meta name="description" content={description} />
            <link rel="canonical" href="https://erdemobilya.com/" />

            {/* Open Graph (Social Media) */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={`${general.brandName} | İstanbul`} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content="https://erdemobilya.com/assets/logos/ERDE-512.png" />
            <meta property="og:url" content="https://erdemobilya.com/" />

            {/* JSON-LD Schema for Local SEO */}
            <script type="application/ld+json">
                {JSON.stringify(schemaMarkup)}
            </script>
        </Helmet>
    );
};

export default SEO;
